import colors from '_containers/Theme/corporate/colors';


export default {
  background: colors.all.neutralWhite,
  borderRadius: 0
};
